import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { GroupiDetailComponent } from './pages/group-i/detail-level/groupidetails.component';
import { TierSetupComponent } from './pages/management/tiersetup/tiersetup.component';
import { EWConfigurationComponent } from './pages/management/ewconfiguration/ewconfiguration.component';
import { HistoryComponent } from './pages/management/history/history.component';
import { ContingencyPCSComponent } from './pages/pcs/contingency-pcs/contingency-pcs.component';
import { ContingencyMasterTablesComponent } from './pages/pcs/contingency-master-tables/contingency-master-tables.component';
import { PeriodsComponent } from './pages/management/periods/periods.component';
import { DomicileComponent } from './pages/kpi/domicile/domicile.component';
import { AssignedUserComponent } from './pages/kpi/assigned-user/assigned-user.component';
import { MsalGuard } from './msal';
import { GroupitierComponent } from './pages/group-i/tier-level/groupitier.component';
import { GroupirouteComponent } from './pages/group-i/route-level/groupiroute.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';

const routes: Routes = [
	{ path: '', component: HomeComponent, pathMatch: 'full', data: { breadcrumb: 'Dashboard' }, canActivate: [MsalGuard] },
	{ path: 'home', component: HomeComponent, data: { breadcrumb: 'Dashboard' }, canActivate: [MsalGuard] },
	//group-i
	{ path: 'tier-level', component: GroupitierComponent, data: { breadcrumb: 'Tier Level' }, canActivate: [MsalGuard] },
	{ path: 'route-level', component: GroupirouteComponent, data: { breadcrumb: 'Route Level' }, canActivate: [MsalGuard] },
	{ path: 'detail-level', component: GroupiDetailComponent, data: { breadcrumb: 'Detail Level' }, canActivate: [MsalGuard] },
	//kpi
	{
		path: '',
		data: { breadcrumb: 'KPI' },
		children: [
			{ path: 'domicile', component: DomicileComponent, data: { breadcrumb: 'Domicile' }, canActivate: [MsalGuard] },
			{ path: 'assigneduser', component: AssignedUserComponent, data: { breadcrumb: 'Assigned User' }, canActivate: [MsalGuard] }
		]},
	//management
	{
		path: '',
		data: { breadcrumb: 'Management' },
		children: [
			{ path: 'tier-setup', component: TierSetupComponent, data: { breadcrumb: 'Tier Setup' }, canActivate: [MsalGuard] },
			{ path: 'ew-configuration', component: EWConfigurationComponent, data: { breadcrumb: 'E/W Configuration' }, canActivate: [MsalGuard] },
			{ path: 'history', component: HistoryComponent, data: { breadcrumb: 'History' }, canActivate: [MsalGuard] },
			{ path: 'periods', component: PeriodsComponent, data: { breadcrumb: 'Periods' }, canActivate: [MsalGuard] }
		]},
	//pcs
	{
		path: '',
		data: { breadcrumb: 'PCS' },
		children: [
			{ path: 'contingency-pcs', component: ContingencyPCSComponent, data: { breadcrumb: 'Contingency PCS' }, canActivate: [MsalGuard] },
			{ path: 'contingency-master-tables', component: ContingencyMasterTablesComponent, data: { breadcrumb: 'Contingency Master Tables' }, canActivate: [MsalGuard] },
		]},
	{ path: 'unauthorized', component: UnauthorizedComponent }
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
